import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=ef65894a&scoped=true&"
import script from "./feedback.js?vue&type=script&lang=js&"
export * from "./feedback.js?vue&type=script&lang=js&"
import style0 from "./feedback.less?vue&type=style&index=0&id=ef65894a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef65894a",
  null
  
)

export default component.exports